import { ElementRef, HostListener } from '@angular/core';
import {
	Component,
	OnInit,
	Input,
	ViewEncapsulation,
	Output,
	EventEmitter,
} from '@angular/core';
import { isNotNull, isNull } from '../../util/check';
import { FnToasterService } from '../toaster/fn-toaster';

export interface FnTagData {
	id?: number | string;
	name: string;
	primaryKey?: number;
}

@Component({
	selector: 'fn-tag',
	templateUrl: 'fn-tags.component.html',
	encapsulation: ViewEncapsulation.None,
})
export class FnTagComponent implements OnInit {
	/**
	 * boolean variable no default selected tags
	 */
	 isShowCustomLabel = false;
	/**
	 * boolean variable to show label on Ui.
	 */
	@Input() showLabel: boolean;
	/**
	 * variable to show placeholder in fntag
	 */
	@Input() placeholder: string;
	/**
	 * variable to bind selected tags List of FnTagData type
	 */
	@Input() selectedTags: Array<FnTagData>;
	/**
	 * variable to show scroll on selected Tag labels if Tags Label increases.
	 */
	@Input() scrollMaxHeight = '180px';
	/**
	 * boolean variable to allow add tag via promise
	 */
	@Input() isAddViaAjax: boolean;
	/**
	 * boolean variable to hide selected tag from dropdown if true.
	 * default value is true.
	 */
	@Input() hideSelected = true;
	/**
	 * variable to append dropdown to html element.
	 */
	@Input() appendTo: string;
	/**
	 * variable to show items in dropdown
	 */
	@Input() itemTags: Array<FnTagData> = [];

	/**
	 * Input variabe to add tag of max Length
	 */
	@Input() maxLength = 255;
	/**
	 *  Input variabe to store tagInput Name
	 */
	@Input() tagName = 'Tag';
	/**
	 *  Input variabe to used to show delete icon.
	 */
	@Input() isShowDelete = true;
	/**
	 *  Input variabe to used to show default custom label;
	 */
	@Input() showOnlyPlaceholder = false;
	/**
	 *  Input variabe to used to show default custom label;
	 */
	@Input() isClearOnBackspace = false;
	/**
	 *  Input variabe to disable
	 */
	@Input() isDisabled : boolean;
	/**
	 * variable to store error message
	 */
	private errorMessage:string;
	/**
	 * EventEmitter Emit all selected item on delete and add
	 */
	@Output() addCallback: EventEmitter<any> = new EventEmitter();
	/**
	 * EventEmitter Emit new selected item or delete item
	 */
	 @Output() updateCallback: EventEmitter<{action:string, fnTag:FnTagData}> = new EventEmitter();
	/**
	 * cutom add Tag Function allow to add Tag.
	 */
	addTagFn: (name: string) => void;
	/**
	 * EventEmitter  Emit to on tag add if isAddViaAjax true and retrun value in callback
	 */
	@Output() addViaAjaxCallback: EventEmitter<{
		name: string;
		callback: (fnTag: FnTagData) => void;
	}> = new EventEmitter();

	/**
	 * object map fo FNtag
	 */
	fnTagMap = {
		isShowPlaceHolder: true,
		isDropDownOpen: false,
	};

	/**
	 * Creates an instance of fn tag component.
	 * @param fnToasterSvcs toadtrSvcs ref to show error message.
	 * @param elementRef ElementRef ref to get element to set dropdown postion if
	 *                   fntag is inside dropdown
	 */
	constructor(
		private fnToasterSvcs: FnToasterService,
		private elementRef: ElementRef
	) {}

	/**
	 * Implementing OnInt Event handler
	 * set AddTagFntion and selectedTags value
	 */
	ngOnInit() {
		this.errorMessage = this.tagName + ' length is greater than '+ this.maxLength+' characters.';
		this.addTagFn = this.isAddViaAjax
			? this.prmoiseAddTagFn
			: this.simpeAddTagFn;
		if (isNull(this.selectedTags)) {
			this.selectedTags = [];
		}
		this.isShowCustomLabel = this.showLabel || this.showOnlyPlaceholder;
	}

	/**
	 * variable to store function to simply add Tag.
	 */
	simpeAddTagFn = (name: string) => {
		const tagObj = { id: name, name };
		if (this.isNotValidTagLength(name) || this.isDuplicateTag(tagObj)) {
			return null;
		}
		return tagObj;
	};
	/**
	 * variable to stroe prmoise function to add tag.
	 */
	prmoiseAddTagFn = (name: string) => {
		return new Promise((resolve,reject) => {
			if(this.isNotValidTagLength(name)){
				return resolve(null);
			}else{
				this.addViaAjaxCallback.emit({
					name,
					callback: (fnTag) => {
						if (isNotNull(fnTag)) {
							this.selectedTags.push(fnTag);
						}
						resolve(fnTag);
					},
				});
			}
		});
	};

	/**
	 * function to emitEmiter all Items on tag selection
	 */
	addAction() {
		setTimeout(() => {
			this.addCallback.emit(this.selectedTags);
		});
	}
	
	addItem(fnTag : FnTagData){
		this.updateCallback.emit({action:"ADD",fnTag});
	}

	/**
	 * method to determine if tag is already exist.
	 * @param fnTagObj FnTagData object to check duplicate Tag
	 * @returns true is duplicate exist
	 */
	isDuplicateTag(fnTagObj: FnTagData) {
		const index = this.selectedTags.findIndex(
			(tagObj) => tagObj.name === fnTagObj.name
		);
		if (index === -1) {
			this.selectedTags.push(fnTagObj);
			return false;
		} else {
			this.fnToasterSvcs.error('List name already exist');
			return true;
		}
	}

	/**
	 * method to delete remove selected tag on click
	 * @param fnTagData FnTagData ref
	 */
	filterTags(fnTagData: FnTagData) {
		this.selectedTags = this.selectedTags.filter((el) => {
			return el.name !== fnTagData.name;
		});
		this.addCallback.emit(this.selectedTags);
		this.removeItem(fnTagData);
	}
	removeItem(item: any){
		this.addCallback.emit(this.selectedTags);
		this.updateCallback.emit({action:"DELETE",fnTag:item.value});
	}
	/**
	 * On focus method to hide custom placeholder
	 */
	onFocus(event: Event) {
		this.fnTagMap.isShowPlaceHolder = false;
	}
	/**
	 * On focus method to show custom placeholder
	 */
	onBlur(event: Event) {
		this.fnTagMap.isShowPlaceHolder = true;
	}
	/**
	 * method to set position of dropdown if append to value is given
	 */
	onOpen() {
		if (this.appendTo) {
			this.updateDropDownPosition();
		}
	}
	isNotValidTagLength(name: string) {
		if (name.length > this.maxLength) {
			this.fnToasterSvcs.error(this.errorMessage);
			return true;
		}
		return false;
	}
	/**
	 * method to update DropPosition
	 */
	private updateDropDownPosition() {
		const select = this.elementRef.nativeElement as HTMLElement;
		const parentElem = document.querySelector(this.appendTo) as HTMLElement;
		const dropDown = document.querySelector('ng-dropdown-panel') as HTMLElement;
		if (!dropDown) {
			setTimeout(() => {
				this.updateDropDownPosition();
			});
		} else {
			const parentDomRect = parentElem.getBoundingClientRect();
			const selectDomRect = select.getBoundingClientRect();
			const offsetLeft = selectDomRect.left - parentDomRect.left;
			dropDown.style.left = offsetLeft + 'px';
			dropDown.style.width = selectDomRect.width + 'px';
			dropDown.style.minWidth = selectDomRect.width + 'px';
		}
	}
	@HostListener('window:resize', ['$event'])
	onResize(event?: Event) {
		if (this.fnTagMap.isDropDownOpen) {
			this.onOpen();
		}
	}
}
